import { ReactNode } from "react";
import styles from "./index.module.scss";

type TitleProps = {
    children: ReactNode;
    color?: "black" | "white";
}

export const Title = (props: TitleProps) => {
    const colorClass = props.color === "white" ? styles.white : styles.black;
    return (
        <div className={`${styles.title} ${colorClass}`}>
            <h1>
                {props.children}
            </h1>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="1"
                viewBox="0 0 371 1"
                fill="none"
                className={styles.line}
                style={{ maxWidth: 371 }}
            >
                <path d="M0 0.5H371"/>
            </svg>
        </div>
    );
};